import React from "react";
import styled from "styled-components";
import { NavLink, useLocation } from "react-router-dom";
import { FaReply } from "react-icons/fa";
import { useSelector } from "react-redux";
import { selectIsLightMode, selectSuggestionsLoading, selectDetailsLoading } from "../../../../mainApp/features/DataSlice/dataSlice";

const StyledBackButton = styled(NavLink)`
  -webkit-tap-highlight-color: transparent;
  width: 2rem;
  height: 2rem;
  position: fixed;
  top: 16px;
  left: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.color.white};
  text-decoration: none;
  transition: color 0.3s ease, opacity 0.3s ease;
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "auto")}; /* Blokada podczas ładowania */

  &:hover {
    color: ${({ theme }) => theme.color.dragonRed};
  }

  ${({ path, theme }) =>
    (path === "/regulations" || path === "/policy") &&
    `
    @media (max-width: 970px) {
      background-color: ${theme.color.spotifyBlack};
      width: 100%;
      height: 60px;
      top: 0;
      left: 0;
      padding-left: 20px;
      box-sizing: border-box;
      justify-content: flex-start;
      border-radius: 0;
    }
  `}

  ${({ is404, theme }) =>
    is404
      ? `
    @media (min-width: 970px) {
      display: none;
    }
  `
      : `
    @media (min-width: ${theme.breakpoint.mobileMax}px) {
      display: none;
    }
  `}

  ${({ isLight }) =>
    isLight &&
    `
    color: #202638;
    &:hover {
      color: ${({ theme }) => theme.color.dragonOrange};
    }
  `}
`;

const BackButton = ({ is404 }) => {
  const location = useLocation();
  const siteTheme = useSelector(selectIsLightMode);
  const suggestionsLoading = useSelector(selectSuggestionsLoading);
  const detailsLoading = useSelector(selectDetailsLoading);
  const isLoading = suggestionsLoading || detailsLoading; // Blokada, gdy którekolwiek ładowanie trwa

  let target;
  if (location.pathname === "/regulations" || location.pathname === "/policy") {
    target = "/settings/policy";
  } else {
    target = is404 ? '/profile' : '/home';
  }

  return (
    //dodać isLight={siteTheme} !!!
    <StyledBackButton
      to={target}
      isLoading={isLoading}
      is404={is404}
      path={location.pathname}
    >
      <FaReply size={29} />
    </StyledBackButton>
  );
};

export default BackButton;